export const onboardingStepsSelector = (state) => state.onboarding.steps;
export const sidebarSelector = (state) => state.onboarding.sidebar;
